(function(){ var landers=document.querySelectorAll('.rh-lander-2026'); landers.forEach(function(l){l.classList.add('rh-ready')}); })();
(function(){ var BUNDLE_VARIANT_IDS = [50616027250911, 50616027283679]; var SALMON_OIL_VARIANT_ID = 50579189399775; var GIFT_PROPERTY_KEY = '_rh_gift'; function getSectionsForDrawer(cartDrawer){ if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') { try { return cartDrawer.getSectionsToRender().map(function(s){ return s.section || s.id; }).join(','); } catch(e) {} } return ''; } function reloadCartSections(){ return fetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }) .then(function(r){ return r.json(); }) .then(function(sections){ if (sections && sections['cart-drawer']) { var drawerWrap = document.getElementById('shopify-section-cart-drawer'); if (drawerWrap) { drawerWrap.innerHTML = sections['cart-drawer']; } else { var d = document.querySelector('cart-drawer'); if (d) { var parser = new DOMParser(); var doc = parser.parseFromString(sections['cart-drawer'], 'text/html'); var newD = doc.querySelector('cart-drawer'); if (newD) d.parentNode.replaceChild(newD, d); } } } if (sections && sections['cart-icon-bubble']) { var bubbleWrap = document.getElementById('shopify-section-cart-icon-bubble'); if (bubbleWrap) { bubbleWrap.innerHTML = sections['cart-icon-bubble']; } } }) .catch(function(err){ console.warn('[rh-lander] reload sections failed', err); }); } function openDrawer(){ setTimeout(function(){ var d = document.querySelector('cart-drawer'); if (!d) return; if (typeof d.open === 'function') { d.open(); } else { d.classList.add('active','animate','is-open'); document.body.classList.add('overflow-hidden'); } }, 80); } function refreshDrawer(){ return reloadCartSections(); } function rhAddToCart(btn, variantId){ var originalText = btn.textContent; btn.disabled = true; btn.textContent = 'מוסיף לעגלה...'; var bundle = btn.closest('.rh-bundle'); var picker = bundle && bundle.querySelector('[data-bundle-picker]'); var sellingPlanId = null; if (picker) { var activeMode = picker.querySelector('input[type="radio"]:checked'); if (activeMode && activeMode.value === 'subscription') { var sel = picker.querySelector('[data-freq-select]'); if (sel && sel.value) sellingPlanId = sel.value; } } var mainItem = { id: variantId, quantity: 1 }; if (sellingPlanId) mainItem.selling_plan = sellingPlanId; var body = { items: [ mainItem, { id: SALMON_OIL_VARIANT_ID, quantity: 1, properties: (function(){ var p = {}; p[GIFT_PROPERTY_KEY] = 'true'; p['🎁 מתנה'] = 'שמן סלמון — מתנת חג'; return p; })() } ] }; var sections = getSectionsForDrawer(cartDrawer); if (sections) { body.sections = sections; body.sections_url = window.location.pathname; } fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: body.items }) }) .then(function(res){ if (!res.ok) { return res.json().catch(function(){return {}}).then(function(err){ throw new Error(err.description || err.message || 'add failed'); }); } return res.json(); }) .then(function(data){ try { sessionStorage.setItem('rhOpenCartAfterReload', '1'); } catch(e) {} btn.textContent = '✓ נוסף — פותח עגלה...'; location.reload(); }) .catch(function(err){ console.warn('[rh-lander] cart add failed:', err); btn.disabled = false; btn.textContent = 'שגיאה — נסה שוב'; setTimeout(function(){ btn.textContent = originalText; }, 3000); }); } function rhCheckOpenCartFlag(){ try { if (sessionStorage.getItem('rhOpenCartAfterReload') === '1') { sessionStorage.removeItem('rhOpenCartAfterReload'); setTimeout(function(){ var d = document.querySelector('cart-drawer'); if (!d) return; if (typeof d.open === 'function') { d.open(); } else { d.classList.add('active','animate','is-open'); document.body.classList.add('overflow-hidden'); } }, 400); } } catch(e){} } function rhHighlightGiftInDrawer(){ var d = document.querySelector('cart-drawer'); if (!d) return; var items = d.querySelectorAll('.cart-item, tr.cart-item, [id^="CartDrawer-Item"], cart-drawer-items li, cart-drawer-items tr'); items.forEach(function(item){ if (item.dataset.rhGiftProcessed === '1') return; var isGift = false; var links = item.querySelectorAll('a[href]'); for (var i=0; i<links.length; i++){ var href = links[i].getAttribute('href') || ''; if (href.indexOf('salmon-oil') > -1 || href.indexOf('salmon_oil') > -1 || href.indexOf('50579189399775') > -1) { isGift = true; break; } } if (!isGift) { var vinputs = item.querySelectorAll('input[name*="id"], input[name*="variant"]'); for (var j=0; j<vinputs.length; j++){ if ((vinputs[j].value || '') === '50579189399775') { isGift = true; break; } } } if (!isGift) return; item.dataset.rhGiftProcessed = '1'; item.classList.add('rh-cart-gift-item'); var parent = item.parentNode; if (parent && !parent.querySelector('.rh-cart-gift-banner[data-for="' + (item.id || 'gift') + '"]')) { var banner = document.createElement('div'); banner.className = 'rh-cart-gift-banner'; banner.dataset.for = item.id || 'gift'; banner.innerHTML = '🎁 המתנה שלך — <strong>שמן סלמון פראי חינם!</strong>'; parent.insertBefore(banner, item); } }); } function rhWatchDrawerForGift(){ var d = document.querySelector('cart-drawer'); if (!d || d.dataset.rhGiftWatcherActive === '1') return; d.dataset.rhGiftWatcherActive = '1'; if (window.MutationObserver) { new MutationObserver(function(){ window.requestAnimationFrame(rhHighlightGiftInDrawer); }).observe(d, { childList: true, subtree: true }); } setInterval(rhHighlightGiftInDrawer, 800); rhHighlightGiftInDrawer(); } var rhMonitorRunning = false; function rhStartCartMonitor(){ if (rhMonitorRunning) return; rhMonitorRunning = true; var checking = false; function check(){ if (checking) return; checking = true; fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){ var hasBundle = cart.items.some(function(item){ return BUNDLE_VARIANT_IDS.indexOf(item.variant_id) !== -1; }); var giftItems = cart.items.filter(function(item){ return item.variant_id === SALMON_OIL_VARIANT_ID && item.properties && item.properties[GIFT_PROPERTY_KEY] === 'true'; }); if (!hasBundle && giftItems.length) { var promises = giftItems.map(function(gi){ return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type':'application/json','Accept':'application/json' }, body: JSON.stringify({ id: gi.key, quantity: 0 }) }); }); Promise.all(promises).then(function(){ var cartDrawer = document.querySelector('cart-drawer'); refreshDrawer(cartDrawer); }).catch(function(){}); } checking = false; }).catch(function(){ checking = false; }); } setInterval(check, 1200); document.addEventListener('cart:refresh', check); document.addEventListener('cart:update', check); var cartDrawer = document.querySelector('cart-drawer'); if (cartDrawer && window.MutationObserver) { new MutationObserver(check).observe(cartDrawer, { childList: true, subtree: true }); } } function rhInitPickers(lander){ var pickers=lander.querySelectorAll('[data-bundle-picker]'); pickers.forEach(function(picker){ var opts=picker.querySelectorAll('.rh-sub-opt'); var bundle=picker.closest('.rh-bundle'); var priceEl=bundle && bundle.querySelector('.rh-price-new'); var saveEl=bundle && bundle.querySelector('.rh-price-save'); var freqSel=picker.querySelector('[data-freq-select]'); var freqTextEl=picker.querySelector('[data-sub-freq-text]'); function updateFreqText(){ if(freqSel && freqTextEl){ var opt=freqSel.options[freqSel.selectedIndex]; if(opt)freqTextEl.textContent=opt.textContent; } } function update(){ var checked=picker.querySelector('input[type="radio"]:checked'); if(!checked)return; var mode=checked.value; opts.forEach(function(o){o.classList.toggle('rh-sub-opt--active',o.dataset.mode===mode)}); if(priceEl){var p=mode==='subscription'?priceEl.dataset.priceSub:priceEl.dataset.priceOnetime;if(p)priceEl.textContent='₪'+p} if(saveEl){var s=mode==='subscription'?saveEl.dataset.saveSub:saveEl.dataset.saveOnetime;if(s)saveEl.textContent=s} updateFreqText(); } picker.addEventListener('change',update); update(); }); } function rhInitLander(){ var landers=document.querySelectorAll('.rh-lander-2026'); landers.forEach(function(lander){ if(lander.dataset.jsInitialized)return; lander.dataset.jsInitialized='true'; rhInitPickers(lander); var buttons=lander.querySelectorAll('.rh-cta'); buttons.forEach(function(btn){ btn.addEventListener('click',function(){ var variantId=btn.dataset.variantId; if(!variantId)return; rhAddToCart(btn, variantId); }); }); var anchors=lander.querySelectorAll('a[href^="#rh-"]'); anchors.forEach(function(a){ a.addEventListener('click',function(e){ e.preventDefault(); if(a.hasAttribute('data-rh-scroll-cta')){ var firstCta=lander.querySelector('.rh-bundle .rh-cta'); if(firstCta){firstCta.scrollIntoView({behavior:'smooth',block:'center'});return} } if(a.hasAttribute('data-rh-more-hint')){ var featCta=lander.querySelector('.rh-bundle--featured .rh-cta'); if(featCta){featCta.scrollIntoView({behavior:'smooth',block:'center'});return} } var target=lander.querySelector(a.getAttribute('href')); if(target){target.scrollIntoView({behavior:'smooth',block:'start'})} }); }); }); rhStartCartMonitor(); rhCheckOpenCartFlag(); rhWatchDrawerForGift(); } if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',rhInitLander)}else{setTimeout(rhInitLander,50)} })(); (function(){ function attachSoundHandler(card){ if(card.dataset.pupsReviewInit)return; card.dataset.pupsReviewInit='1'; var video=card.querySelector('.pups-review-video'); var soundBtn=card.querySelector('.pups-review-sound'); if(!video||!soundBtn)return; var toggleSound=function(e){ if(e){e.stopPropagation();e.preventDefault()} document.querySelectorAll('.pups-review-card').forEach(function(other){ if(other!==card){var ov=other.querySelector('.pups-review-video');if(ov){ov.muted=true}other.classList.remove('pups-review-unmuted')} }); if(video.muted){video.muted=false;video.play().catch(function(){});card.classList.add('pups-review-unmuted')} else{video.muted=true;card.classList.remove('pups-review-unmuted')} }; soundBtn.addEventListener('click',toggleSound); } function initReviewsSlider(){ var slider=document.querySelector('.pups-reviews-grid'); if(!slider||slider.dataset.rhSliderInit)return; slider.dataset.rhSliderInit='1'; var originals=Array.from(slider.querySelectorAll('.pups-review-card')); originals.forEach(function(c){ var clone=c.cloneNode(true); clone.removeAttribute('data-pups-review-init'); clone.dataset.clone='1'; var v=clone.querySelector('video'); if(v){v.muted=true;v.play().catch(function(){})} slider.appendChild(clone); }); slider.querySelectorAll('.pups-review-card').forEach(attachSoundHandler); var pauseUntil=0; var speed=0.4; var halfWidth=0; function measure(){halfWidth=slider.scrollWidth/2} setTimeout(measure,400); setTimeout(measure,1200); window.addEventListener('resize',measure); function tick(){ if(halfWidth && Date.now()>pauseUntil && !document.hidden){ slider.scrollLeft+=speed; if(slider.scrollLeft>=halfWidth){slider.scrollLeft-=halfWidth} } requestAnimationFrame(tick); } requestAnimationFrame(tick); var pauseFor=function(ms){pauseUntil=Date.now()+ms}; slider.addEventListener('touchstart',function(){pauseFor(6000)},{passive:true}); slider.addEventListener('wheel',function(){pauseFor(3000)},{passive:true}); slider.addEventListener('mouseenter',function(){pauseFor(999999)}); slider.addEventListener('mouseleave',function(){pauseUntil=0}); var isDown=false, startX=0, startScroll=0, moved=false; slider.addEventListener('mousedown',function(e){ if(e.target.closest('.pups-review-sound'))return; isDown=true;moved=false; slider.classList.add('rh-dragging'); startX=e.pageX; startScroll=slider.scrollLeft; e.preventDefault(); }); document.addEventListener('mouseup',function(){ if(isDown){slider.classList.remove('rh-dragging')} isDown=false; }); slider.addEventListener('mousemove',function(e){ if(!isDown)return; var walk=e.pageX-startX; if(Math.abs(walk)>3)moved=true; slider.scrollLeft=startScroll-walk; }); slider.addEventListener('click',function(e){ if(moved){e.preventDefault();e.stopPropagation();moved=false} },true); } if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initReviewsSlider)} else{setTimeout(initReviewsSlider,100)} })(); (function(){ function initReviews(){ document.querySelectorAll('.pups-dental-reviews').forEach(function(root){ if(root.dataset.jsInitialized)return; root.dataset.jsInitialized='true'; var track=root.querySelector('.pups-dental-slider-track'); var prevBtn=root.querySelector('.pups-dental-prev-btn'); var nextBtn=root.querySelector('.pups-dental-next-btn'); if(!track||!prevBtn||!nextBtn)return; var cards=track.querySelectorAll('.pups-dental-review-card'); var total=cards.length; var idx=0; function update(){track.style.transform='translateX('+(idx*100)+'%)';prevBtn.classList.toggle('disabled',idx===0);nextBtn.classList.toggle('disabled',idx===total-1)} nextBtn.addEventListener('click',function(){if(idx<total-1){idx++;update()}}); prevBtn.addEventListener('click',function(){if(idx>0){idx--;update()}}); update(); }); } if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initReviews)}else{setTimeout(initReviews,50)} })(); (function(){ function initV2(){ var root = document.querySelector('.rh-bundle-picker-v2'); if(!root || root.dataset.v2Init) return; root.dataset.v2Init = '1'; var cards = root.querySelectorAll('.rh-b2-card'); var ctaSub = root.querySelector('.rh-b2-cta--sub'); var ctaOne = root.querySelector('.rh-b2-cta--onetime'); var priceOneEl = root.querySelector('[data-price-onetime-target]'); var priceSubEl = root.querySelector('[data-price-sub-target]'); var freqSelect = root.querySelector('#rh-b2-freq-select'); function getSelected(){ var sel = root.querySelector('.rh-b2-card.is-selected'); return sel || cards[0]; } function updateCTAs(){ var c = getSelected(); if(!c) return; var onePrice = c.dataset.priceOnetime; var subPrice = c.dataset.priceSub; if(priceOneEl) priceOneEl.textContent = '₪' + onePrice; if(priceSubEl) priceSubEl.textContent = '₪' + subPrice; } cards.forEach(function(card){ card.addEventListener('click', function(e){ cards.forEach(function(c){ c.classList.remove('is-selected'); var i=c.querySelector('input'); if(i) i.checked = false; }); card.classList.add('is-selected'); var input = card.querySelector('input[type="radio"]'); if(input) input.checked = true; updateCTAs(); }); }); function addToCart(mode){ var card = getSelected(); if(!card) return; var variantId = mode === 'subscription' ? card.dataset.variantSub : card.dataset.variantOnetime; var sellingPlan = mode === 'subscription' ? (freqSelect ? freqSelect.value : '4848386271') : null; var payload = { id: parseInt(variantId, 10), quantity: 1 }; if(sellingPlan) payload.selling_plan = parseInt(sellingPlan, 10); var btn = mode === 'subscription' ? ctaSub : ctaOne; if(btn) btn.classList.add('is-loading'); fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(payload) }).then(function(r){ return r.json(); }) .then(function(){ window.location.href = '/checkout'; }) .catch(function(){ window.location.href = '/cart'; }); } if(ctaSub) ctaSub.addEventListener('click', function(){ addToCart('subscription'); }); if(ctaOne) ctaOne.addEventListener('click', function(){ addToCart('onetime'); }); updateCTAs(); } if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', initV2); } else { setTimeout(initV2, 50); } })();

/* ============ RH BUNDLE PICKER V3 — logic ============ */
(function(){
  function init(){
    var root = document.querySelector('.rh-b3');
    if(!root || root.dataset.b3init) return;
    root.dataset.b3init = '1';

    var cards = root.querySelectorAll('.rh-b3-card');
    var modes = root.querySelectorAll('.rh-b3-mode');
    var freqSel = root.querySelector('#rh-b3-freq');
    var atc = root.querySelector('#rh-b3-atc');

    var modePriceOne = root.querySelector('[data-mode-price-onetime]');
    var modePriceSub = root.querySelector('[data-mode-price-sub]');
    var modePriceOld = root.querySelector('[data-mode-price-old]');

    function getSelectedCard(){
      var s = root.querySelector('.rh-b3-card.is-selected');
      return s || cards[0];
    }
    function getSelectedMode(){
      var s = root.querySelector('.rh-b3-mode.is-selected');
      return s ? s.dataset.mode : 'subscription';
    }

    function refresh(){
      var c = getSelectedCard();
      if(!c) return;
      var priceOne = c.dataset.priceOnetime;
      var priceSub = c.dataset.priceSub;
      if(modePriceOne) modePriceOne.textContent = priceOne;
      if(modePriceSub) modePriceSub.textContent = priceSub;
      if(modePriceOld) modePriceOld.textContent = priceOne;
    }

    cards.forEach(function(card){
      card.addEventListener('click', function(){
        cards.forEach(function(c){ c.classList.remove('is-selected'); var i=c.querySelector('input'); if(i) i.checked = false; });
        card.classList.add('is-selected');
        var input = card.querySelector('input[type="radio"]');
        if(input) input.checked = true;
        refresh();
      });
    });

    modes.forEach(function(m){
      m.addEventListener('click', function(e){
        // don't hijack clicks on the frequency select itself
        if(e.target.closest('select, option')) return;
        modes.forEach(function(x){ x.classList.remove('is-selected'); var i=x.querySelector('input'); if(i) i.checked = false; });
        m.classList.add('is-selected');
        var input = m.querySelector('input[type="radio"]');
        if(input) input.checked = true;
      });
    });

    if(atc){
      atc.addEventListener('click', function(){
        var card = getSelectedCard();
        if(!card) return;
        var mode = getSelectedMode();
        var variantId = parseInt(card.dataset.variant, 10);
        var payload = { id: variantId, quantity: 1 };
        if(mode === 'subscription' && freqSel){
          payload.selling_plan = parseInt(freqSel.value, 10);
        }
        atc.classList.add('is-loading');
        var originalText = atc.textContent;
        atc.textContent = 'מוסיף לסל...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(payload)
        }).then(function(r){ return r.json(); })
          .then(function(){ window.location.href = '/checkout'; })
          .catch(function(){ window.location.href = '/cart'; });
      });
    }

    refresh();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 60);
  }
})();



/* ============ UGC video reviews — from dental/salmon ============ */
(function(){
  function initReviewsSlider(){
    var slider=document.querySelector('.pups-reviews-grid');
    if(!slider||slider.dataset.rhSliderInit)return;
    slider.dataset.rhSliderInit='1';

    // Clone all cards once for seamless infinite loop
    var originals=Array.from(slider.querySelectorAll('.pups-review-card'));
    originals.forEach(function(c){
      var clone=c.cloneNode(true);
      clone.removeAttribute('data-pups-review-init');
      clone.dataset.clone='1';
      // clone videos need explicit play attempt
      var v=clone.querySelector('video');
      if(v){v.muted=true;v.play().catch(function(){})}
      slider.appendChild(clone);
    });
    // Attach sound handlers to all cards (originals + clones)
    slider.querySelectorAll('.pups-review-card').forEach(attachSoundHandler);

    var pauseUntil=0;
    var speed=0.4;
    var halfWidth=0;
    function measure(){halfWidth=slider.scrollWidth/2}
    setTimeout(measure,400);
    setTimeout(measure,1200);
    window.addEventListener('resize',measure);

    function tick(){
      if(halfWidth && Date.now()>pauseUntil && !document.hidden){
        slider.scrollLeft+=speed;
        if(slider.scrollLeft>=halfWidth){slider.scrollLeft-=halfWidth}
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);

    var pauseFor=function(ms){pauseUntil=Date.now()+ms};
    // Touch (mobile swipe): pause 6s so the user can view
    slider.addEventListener('touchstart',function(){pauseFor(6000)},{passive:true});
    // Wheel scroll on slider: pause 3s
    slider.addEventListener('wheel',function(){pauseFor(3000)},{passive:true});
    // Hover on desktop: pause while over
    slider.addEventListener('mouseenter',function(){pauseFor(999999)});
    slider.addEventListener('mouseleave',function(){pauseUntil=0});

    // Mouse drag on desktop (click-drag to scroll)
    var isDown=false, startX=0, startScroll=0, moved=false;
    slider.addEventListener('mousedown',function(e){
      if(e.target.closest('.pups-review-sound'))return; // let button click through
      isDown=true;moved=false;
      slider.classList.add('rh-dragging');
      startX=e.pageX;
      startScroll=slider.scrollLeft;
      e.preventDefault();
    });
    document.addEventListener('mouseup',function(){
      if(isDown){slider.classList.remove('rh-dragging')}
      isDown=false;
    });
    slider.addEventListener('mousemove',function(e){
      if(!isDown)return;
      var walk=e.pageX-startX;
      if(Math.abs(walk)>3)moved=true;
      slider.scrollLeft=startScroll-walk;
    });
    // Suppress click if drag happened
    slider.addEventListener('click',function(e){
      if(moved){e.preventDefault();e.stopPropagation();moved=false}
    },true);
  }

function initReviewsSlider(){
    var slider=document.querySelector('.pups-reviews-grid');
    if(!slider||slider.dataset.rhSliderInit)return;
    slider.dataset.rhSliderInit='1';

    // Clone all cards once for seamless infinite loop
    var originals=Array.from(slider.querySelectorAll('.pups-review-card'));
    originals.forEach(function(c){
      var clone=c.cloneNode(true);
      clone.removeAttribute('data-pups-review-init');
      clone.dataset.clone='1';
      // clone videos need explicit play attempt
      var v=clone.querySelector('video');
      if(v){v.muted=true;v.play().catch(function(){})}
      slider.appendChild(clone);
    });
    // Attach sound handlers to all cards (originals + clones)
    slider.querySelectorAll('.pups-review-card').forEach(attachSoundHandler);

    var pauseUntil=0;
    var speed=0.4;
    var halfWidth=0;
    function measure(){halfWidth=slider.scrollWidth/2}
    setTimeout(measure,400);
    setTimeout(measure,1200);
    window.addEventListener('resize',measure);

    function tick(){
      if(halfWidth && Date.now()>pauseUntil && !document.hidden){
        slider.scrollLeft+=speed;
        if(slider.scrollLeft>=halfWidth){slider.scrollLeft-=halfWidth}
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);

    var pauseFor=function(ms){pauseUntil=Date.now()+ms};
    // Touch (mobile swipe): pause 6s so the user can view
    slider.addEventListener('touchstart',function(){pauseFor(6000)},{passive:true});
    // Wheel scroll on slider: pause 3s
    slider.addEventListener('wheel',function(){pauseFor(3000)},{passive:true});
    // Hover on desktop: pause while over
    slider.addEventListener('mouseenter',function(){pauseFor(999999)});
    slider.addEventListener('mouseleave',function(){pauseUntil=0});

    // Mouse drag on desktop (click-drag to scroll)
    var isDown=false, startX=0, startScroll=0, moved=false;
    slider.addEventListener('mousedown',function(e){
      if(e.target.closest('.pups-review-sound'))return; // let button click through
      isDown=true;moved=false;
      slider.classList.add('rh-dragging');
      startX=e.pageX;
      startScroll=slider.scrollLeft;
      e.preventDefault();
    });
    document.addEventListener('mouseup',function(){
      if(isDown){slider.classList.remove('rh-dragging')}
      isDown=false;
    });
    slider.addEventListener('mousemove',function(e){
      if(!isDown)return;
      var walk=e.pageX-startX;
      if(Math.abs(walk)>3)moved=true;
      slider.scrollLeft=startScroll-walk;
    });
    // Suppress click if drag happened
    slider.addEventListener('click',function(e){
      if(moved){e.preventDefault();e.stopPropagation();moved=false}
    },true);
  }
  function initAll(){
    try { if (typeof initReviews === 'function') initReviews(); } catch(e){}
    try { if (typeof initReviewsSlider === 'function') initReviewsSlider(); } catch(e){}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else setTimeout(initAll, 60);
})();


/* ============ Auto-scroll marquee: clone cards for seamless loop ============ */
(function(){
  function initMarquee(){
    var grid = document.querySelector('.pups-reviews-grid');
    if(!grid || grid.dataset.marqueeInit) return;
    var cards = grid.querySelectorAll('.pups-review-card');
    if(cards.length === 0) return;
    grid.dataset.marqueeInit = '1';
    // Clone once for seamless 50% translate loop
    cards.forEach(function(c){
      var clone = c.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      // Do NOT play/unmute cloned videos independently; keep autoplay+muted
      var v = clone.querySelector('video');
      if(v){ v.muted = true; v.autoplay = true; v.loop = true; v.playsInline = true; try{ v.play(); }catch(e){} }
      grid.appendChild(clone);
    });
    // Force all real videos to autoplay+muted (some browsers require explicit call)
    grid.querySelectorAll('video').forEach(function(v){
      v.muted = true;
      try{ v.play(); }catch(e){}
    });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initMarquee);
  } else {
    setTimeout(initMarquee, 100);
  }
})();


/* ============ FORCE inline styles (belt+suspenders — CSS specificity fallback) ============ */
(function(){
  function forceStyles(){
    // 1. Fix onetime price to inline
    document.querySelectorAll('.rh-b3-mode[data-mode="onetime"] .rh-b3-mode-price').forEach(function(el){
      el.style.setProperty('flex-direction', 'row', 'important');
      el.style.setProperty('align-items', 'baseline', 'important');
      el.style.setProperty('gap', '3px', 'important');
      el.style.setProperty('white-space', 'nowrap', 'important');
      el.style.setProperty('min-width', 'auto', 'important');
      el.style.setProperty('display', 'inline-flex', 'important');
    });
    // 2. Fix subscription benefits to be full-width single lines
    document.querySelectorAll('.rh-b3-mode[data-mode="subscription"] .rh-b3-mode-main').forEach(function(el){
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('flex', '1 1 auto', 'important');
    });
    document.querySelectorAll('.rh-b3-mode[data-mode="subscription"] .rh-b3-mode-price').forEach(function(el){
      el.style.setProperty('min-width', 'auto', 'important');
    });
    // 3. Fix freq dropdown to full width
    document.querySelectorAll('.rh-b3-freq').forEach(function(el){
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('min-width', '0', 'important');
    });
    document.querySelectorAll('.rh-b3-freq-wrap').forEach(function(el){
      el.style.setProperty('width', '100%', 'important');
    });
    // 4. Force marquee animation on video grid (in case reduce-motion is on)
    document.querySelectorAll('.pups-reviews-grid').forEach(function(el){
      el.style.setProperty('animation', 'pups-reviews-scroll 55s linear infinite', 'important');
      el.style.setProperty('will-change', 'transform');
      el.style.setProperty('display', 'flex', 'important');
      el.style.setProperty('flex-wrap', 'nowrap', 'important');
      el.style.setProperty('width', 'max-content', 'important');
    });
  }
  function initForce(){
    forceStyles();
    // Re-apply after 300ms in case something else re-rendered
    setTimeout(forceStyles, 300);
    setTimeout(forceStyles, 1000);
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initForce);
  } else {
    setTimeout(initForce, 50);
  }
})();


/* ============ Pause marquee when a video is playing with sound ============ */
(function(){
  function initPauseOnPlay(){
    var grid = document.querySelector('.pups-reviews-grid');
    if(!grid || grid.dataset.pauseCtrlInit) return;
    grid.dataset.pauseCtrlInit = '1';

    function updateState(){
      var anyPlaying = Array.from(grid.querySelectorAll('video')).some(function(v){
        return !v.muted && !v.paused;
      });
      grid.style.setProperty('animation-play-state', anyPlaying ? 'paused' : 'running', 'important');
    }

    // Delegate clicks anywhere in the grid — after sound toggle, check state
    document.addEventListener('click', function(e){
      var withinGrid = e.target.closest('.pups-reviews-grid');
      if(withinGrid){
        // Give the sound toggle a moment to apply
        setTimeout(updateState, 120);
        setTimeout(updateState, 400);
      } else {
        // Click outside: also re-check (in case they closed something)
        setTimeout(updateState, 120);
      }
    }, true);

    // Also react when videos change mute state programmatically
    grid.querySelectorAll('video').forEach(function(v){
      v.addEventListener('volumechange', updateState);
      v.addEventListener('play', updateState);
      v.addEventListener('pause', updateState);
    });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initPauseOnPlay);
  } else {
    setTimeout(initPauseOnPlay, 200);
  }
})();


/* ============ NEW UGC video carousel logic — no marquee, IntersectionObserver + click-to-sound + arrows ============ */
(function(){
  function initUGCCarousel(){
    var grid = document.querySelector('.pups-reviews-grid');
    var wrap = document.querySelector('.pups-reviews-wrap');
    if(!grid || !wrap || grid.dataset.ugcNewInit) return;
    grid.dataset.ugcNewInit = '1';

    // Remove any leftover cloned cards from earlier marquee runs
    var cards = grid.querySelectorAll('.pups-review-card');
    var seenSrcs = {};
    cards.forEach(function(c){
      var src = c.dataset.videoSrc || '';
      if(seenSrcs[src]) { c.remove(); } else { seenSrcs[src] = 1; }
    });
    // Recompute cards after de-dup
    cards = grid.querySelectorAll('.pups-review-card');

    // Kill any lingering animation
    grid.style.setProperty('animation', 'none', 'important');
    grid.style.setProperty('animation-play-state', 'running', 'important');

    // Set video src lazily (we already have data-video-src on card)
    cards.forEach(function(card){
      var v = card.querySelector('video');
      if(!v) return;
      var src = card.dataset.videoSrc;
      if(src && !v.src) v.src = src;
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.preload = 'metadata';
    });

    // 2) IntersectionObserver — play the video whose center is closest to viewport center
    var currentPlaying = null;
    function playCard(card){
      if(currentPlaying === card) return;
      if(currentPlaying){
        var pv = currentPlaying.querySelector('video');
        if(pv){ pv.pause(); pv.muted = true; }
        currentPlaying.classList.remove('is-playing');
      }
      var v = card.querySelector('video');
      if(!v) return;
      // Do not force unmute — that only happens on click
      v.play().catch(function(){});
      card.classList.add('is-playing');
      currentPlaying = card;
    }
    var io = new IntersectionObserver(function(entries){
      // Find the entry with highest visibility ratio
      var best = null; var bestRatio = 0;
      entries.forEach(function(en){
        if(en.intersectionRatio > bestRatio){ bestRatio = en.intersectionRatio; best = en.target; }
      });
      if(best && bestRatio > 0.55) playCard(best);
    }, { root: grid, threshold: [0, 0.25, 0.5, 0.55, 0.75, 1] });
    cards.forEach(function(c){ io.observe(c); });

    // 3) Click on card = toggle sound + pause/play
    grid.addEventListener('click', function(e){
      var card = e.target.closest('.pups-review-card');
      if(!card) return;
      var v = card.querySelector('video');
      if(!v) return;
      // Toggle: unmuted+playing → mute+pause; muted+playing → unmute+continue playing
      if(!v.muted && !v.paused){
        v.muted = true;
        v.pause();
        card.classList.remove('is-playing');
      } else {
        v.muted = false;
        v.play().catch(function(){ v.muted = true; v.play().catch(function(){}); });
        card.classList.add('is-playing');
        currentPlaying = card;
      }
    });

    // 4) Inject nav arrows (RTL: prev = right, next = left)
    if(!wrap.querySelector('.pups-reviews-nav--prev')){
      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'pups-reviews-nav pups-reviews-nav--prev';
      prev.setAttribute('aria-label', 'סרטון קודם');
      prev.innerHTML = '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'pups-reviews-nav pups-reviews-nav--next';
      next.setAttribute('aria-label', 'סרטון הבא');
      next.innerHTML = '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
      wrap.appendChild(prev);
      wrap.appendChild(next);

      function scrollByCard(dir){
        var first = grid.querySelector('.pups-review-card');
        if(!first) return;
        var w = first.offsetWidth + 14; // gap
        // RTL: prev button (right) → scrollLeft += dir; direction of scroll depends on browser
        // In RTL, scrollLeft goes negative to scroll right visually
        grid.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      prev.addEventListener('click', function(){ scrollByCard(1); });   // right in RTL = scrollLeft positive? actually depends; try +
      next.addEventListener('click', function(){ scrollByCard(-1); });

      function updateNavState(){
        // Check scroll extents. In RTL scrollLeft is negative going right.
        var atStart = grid.scrollLeft >= -5;
        var atEnd = Math.abs(grid.scrollLeft) >= (grid.scrollWidth - grid.clientWidth - 5);
        prev.toggleAttribute('disabled', atEnd);
        next.toggleAttribute('disabled', atStart);
      }
      grid.addEventListener('scroll', updateNavState, { passive: true });
      setTimeout(updateNavState, 100);
    }
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initUGCCarousel);
  } else {
    setTimeout(initUGCCarousel, 100);
  }
})();
